import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { AsistenciaService } from '../_services/asistencia.service';

@Component({
  selector: 'app-reporte-direccion-curso-notificar',
  standalone: false,
  templateUrl: './reporte-direccion-curso-notificar.component.html',
  styleUrls: ['./reporte-direccion-curso-notificar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReporteDireccionCursoNotificarComponent implements OnInit {

  materias: any[];
  fechaAsistencia: string;

  text = new UntypedFormControl('');

  private savingSubject = new BehaviorSubject(false);
  saving$ = this.savingSubject.asObservable();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ReporteDireccionCursoNotificarComponent>,
    private asistenciaService: AsistenciaService,
    private customAlertService: CustomAlertService,
    private snackBar: MatSnackBar) {
    if (this.data) {
      this.materias = this.data.materias;
      this.fechaAsistencia = this.data.fechaAsistencia;
    }
  }

  ngOnInit(): void {
  }

  notificar() {
    this.savingSubject.next(true);
    this.asistenciaService.notificarMateriasSinAsistencia(this.materias, this.text.value, this.fechaAsistencia)
    .subscribe(res => {
        this.savingSubject.next(false);
        this.snackBar.open('Notificación realizada.', null, {duration: 2500});
        this.dialogRef.close();
      }, err => {
        this.savingSubject.next(false);
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `Error al enviar la notificación. ${err.error}. Codigo de error: ${err.statusText}`
        });
      });
  }

}
